import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { AxiosInstance } from '../baseUrl';
import Swal from 'sweetalert2';

const DEFAULT_PRICE = { green: 100, blue: 230, purple: 0 };
const COLOR_META = {
    green:  { badge: '#33B679', bg: '#0a1f12', name: 'Зелений'    },
    blue:   { badge: '#4a90d9', bg: '#0a1628', name: 'Синій'      },
    purple: { badge: '#9b59b6', bg: '#160d24', name: 'Фіолетовий' },
};

export default function DoneEventModal({ show, event, onHide, onSaved }) {
    const [price,        setPrice]        = useState('');
    const [whatHappened, setWhatHappened] = useState('');
    const [homework,     setHomework]     = useState('');
    const [doneTopics,   setDoneTopics]   = useState('');
    const [nextTopics,   setNextTopics]   = useState('');
    const [students,     setStudents]     = useState([]);
    const [loading,      setLoading]      = useState(false);

    useEffect(() => {
        if (!event) return;
        setPrice(DEFAULT_PRICE[event.color_type] ?? '');
        setWhatHappened(''); setHomework(''); setDoneTopics(''); setNextTopics('');
        if (event.color_type === 'purple') {
            AxiosInstance.get(`/events/${event.id}`).then(r => {
                setStudents((r.data.students || []).map(s => ({ ...s, mood: '', homework_note: '' })));
            });
        } else {
            setStudents([]);
        }
    }, [event]);

    const handleStudentField = (id, field, value) =>
        setStudents(prev => prev.map(s => s.id === id ? { ...s, [field]: value } : s));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await AxiosInstance.post(`/events/${event.id}/done`, {
                final_price:   Number(price),
                what_happened: whatHappened,
                homework,
                done_topics:   doneTopics,
                next_topics:   nextTopics,
                student_moods: students.map(s => ({ student_id: s.id, mood: s.mood, homework_note: s.homework_note })),
            });
            Swal.fire({ icon: 'success', title: 'Збережено!', timer: 1500, showConfirmButton: false, background: '#1a1a1a', color: '#e8e8e8' });
            onSaved();
        } catch (err) {
            const msg = err?.response?.data?.detail || 'Не вдалося зберегти';
            Swal.fire({ icon: 'error', title: 'Помилка', text: msg, background: '#1a1a1a', color: '#e8e8e8' });
        } finally {
            setLoading(false);
        }
    };

    if (!event) return null;
    const cm = COLOR_META[event.color_type] || COLOR_META.green;

    return (
        <Modal show={show} onHide={onHide} centered size="lg" contentClassName="border-0 bg-transparent shadow-none">
            <div style={{ background: '#141414', borderRadius: 14, border: '1px solid #242424', boxShadow: '0 24px 64px rgba(0,0,0,0.7)', display: 'flex', flexDirection: 'column', maxHeight: '90vh', overflow: 'hidden' }}>

                {/* Accent bar */}
                <div style={{ height: 3, background: `linear-gradient(90deg, ${cm.badge}, ${cm.badge}44)`, flexShrink: 0 }} />

                {/* Header */}
                <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid #1e1e1e', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ width: 8, height: 8, borderRadius: '50%', background: cm.badge, display: 'inline-block' }} />
                            <span style={{ color: '#f0f0f0', fontWeight: 700, fontSize: 16 }}>Завершити заняття</span>
                        </div>
                        <div style={{ color: '#555', fontSize: 12, marginTop: 3, marginLeft: 16 }}>{event.title}</div>
                    </div>
                    <button onClick={onHide} style={{ background: 'none', border: 'none', color: '#3a3a3a', fontSize: 22, cursor: 'pointer', lineHeight: 1, padding: 0 }}
                        onMouseEnter={e => e.target.style.color = '#888'} onMouseLeave={e => e.target.style.color = '#3a3a3a'}>
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
                    <div style={{ padding: '18px 22px', overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: 10 }}>

                        {/* Price */}
                        <FormSection label="Оплата">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <div style={{ position: 'relative', flex: '0 0 140px' }}>
                                    <input
                                        type="number" value={price} onChange={e => setPrice(e.target.value)}
                                        style={{ ...inputStyle, paddingRight: 36, fontWeight: 700, fontSize: 18, color: cm.badge }}
                                    />
                                    <span style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', color: '#444', fontSize: 14 }}>₴</span>
                                </div>
                                <span style={{ color: '#333', fontSize: 12 }}>
                                    {event.color_type !== 'purple' && `Стандарт: ${DEFAULT_PRICE[event.color_type]} ₴`}
                                    {event.color_type === 'purple' && 'Вкажіть суму вручну'}
                                </span>
                            </div>
                        </FormSection>

                        {/* General fields */}
                        <FormSection label="Хід заняття">
                            <FieldGroup>
                                <FieldLabel>Що відбулось</FieldLabel>
                                <textarea
                                    rows={2} value={whatHappened} onChange={e => setWhatHappened(e.target.value)}
                                    placeholder="Настрій учня, як пройшло загалом..."
                                    style={textareaStyle}
                                />
                            </FieldGroup>
                            <FieldGroup>
                                <FieldLabel>Пройдені теми</FieldLabel>
                                <textarea
                                    rows={2} value={doneTopics} onChange={e => setDoneTopics(e.target.value)}
                                    placeholder="Що вивчили сьогодні..."
                                    style={textareaStyle}
                                />
                            </FieldGroup>
                        </FormSection>

                        <FormSection label="Домашнє завдання та план">
                            <FieldGroup>
                                <FieldLabel>Домашнє завдання</FieldLabel>
                                <textarea
                                    rows={2} value={homework} onChange={e => setHomework(e.target.value)}
                                    placeholder="Що задали додому..."
                                    style={textareaStyle}
                                />
                            </FieldGroup>
                            <FieldGroup>
                                <FieldLabel>Тема наступного заняття</FieldLabel>
                                <textarea
                                    rows={2} value={nextTopics} onChange={e => setNextTopics(e.target.value)}
                                    placeholder="Що планується на наступний раз..."
                                    style={{ ...textareaStyle, borderColor: '#5865f244', background: '#0e0f18' }}
                                />
                                <div style={{ color: '#333', fontSize: 11, marginTop: 4 }}>
                                    Буде показано на майбутньому занятті як «Тема цього заняття»
                                </div>
                            </FieldGroup>
                        </FormSection>

                        {/* Purple students */}
                        {event.color_type === 'purple' && students.length > 0 && (
                            <FormSection label={`Учні (${students.length})`} accentColor="#9b59b6">
                                {students.map(s => (
                                    <div key={s.id} style={{ background: '#0c0c0c', border: '1px solid #222', borderLeft: '2px solid #9b59b666', borderRadius: 8, padding: '12px 14px', marginBottom: 8 }}>
                                        <div style={{ color: '#9b59b6', fontWeight: 600, fontSize: 13, marginBottom: 10 }}>{s.name}</div>
                                        <FieldGroup style={{ marginBottom: 8 }}>
                                            <FieldLabel>Настрій</FieldLabel>
                                            <input
                                                value={s.mood} onChange={e => handleStudentField(s.id, 'mood', e.target.value)}
                                                placeholder="Добре / погано / нейтрально..."
                                                style={inputStyle}
                                            />
                                        </FieldGroup>
                                        <FieldGroup>
                                            <FieldLabel>ДЗ для учня</FieldLabel>
                                            <textarea
                                                rows={2} value={s.homework_note}
                                                onChange={e => handleStudentField(s.id, 'homework_note', e.target.value)}
                                                placeholder="Домашнє для цього учня..."
                                                style={textareaStyle}
                                            />
                                        </FieldGroup>
                                    </div>
                                ))}
                            </FormSection>
                        )}
                    </div>

                    {/* Footer */}
                    <div style={{ padding: '12px 22px 18px', borderTop: '1px solid #1a1a1a', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <button type="button" onClick={onHide} style={{ ...footerBtn, background: '#0f0f0f', border: '1px solid #2a2a2a', color: '#666' }}>
                            Скасувати
                        </button>
                        <button type="submit" disabled={loading} style={{ ...footerBtn, background: cm.badge, border: 'none', color: '#fff', opacity: loading ? 0.65 : 1 }}>
                            {loading ? 'Збереження...' : 'Зберегти'}
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}

const FormSection = ({ label, accentColor = '#2e2e2e', children }) => (
    <div style={{ background: '#0f0f0f', borderRadius: 10, border: '1px solid #1e1e1e', borderLeft: `3px solid ${accentColor}` }}>
        <div style={{ padding: '8px 14px 6px', borderBottom: '1px solid #161616' }}>
            <span style={{ color: '#666', fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.8, fontWeight: 600 }}>{label}</span>
        </div>
        <div style={{ padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 10 }}>{children}</div>
    </div>
);

const FieldGroup = ({ children, style }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, ...style }}>{children}</div>
);

const FieldLabel = ({ children }) => (
    <div style={{ color: '#444', fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.7 }}>{children}</div>
);

const inputStyle = {
    background: '#161616', border: '1px solid #2a2a2a', color: '#e8e8e8',
    borderRadius: 7, padding: '8px 12px', fontSize: 13, width: '100%',
    outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box',
};

const textareaStyle = {
    ...inputStyle,
    resize: 'vertical', lineHeight: 1.5, minHeight: 58,
};

const footerBtn = {
    padding: '8px 20px', borderRadius: 8, cursor: 'pointer',
    fontSize: 13, fontWeight: 600, transition: 'opacity 0.12s',
};
